import { render, staticRenderFns } from "./Slide.vue?vue&type=template&id=3f8f5b54"
import script from "./Slide.vue?vue&type=script&lang=js"
export * from "./Slide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports